exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mail-note[data-v-66c247dd] {\n  margin-bottom: 0.75em;\n}\n.mail-note span[data-v-66c247dd]:first-of-type {\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);

// exports
